import { render, staticRenderFns } from "./step_description_lekarstva.vue?vue&type=template&id=1ef3d270&scoped=true"
import script from "./step_description_lekarstva.vue?vue&type=script&lang=js"
export * from "./step_description_lekarstva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef3d270",
  null
  
)

export default component.exports